import { render, staticRenderFns } from "./AttributeBadge.vue?vue&type=template&id=2ac8ea36&"
import script from "./AttributeBadge.vue?vue&type=script&lang=js&"
export * from "./AttributeBadge.vue?vue&type=script&lang=js&"
import style0 from "./AttributeBadge.vue?vue&type=style&index=0&id=2ac8ea36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports